export default __webpack_public_path__ + "static/media/safetysuit.6a5fcfc3.svg";